import { AboutContainer, Mvv, Who, MvvGrid } from './style';
import Title from '../Title';
import Reveal from '../Reveal';
import MVVItem from '../MVVItem';
import { ABOUT_CONTENT } from '../../constants';

const About = () => {
  return (
    <AboutContainer id="about">
      <Reveal>
        <Who>
          <Title title="Quem somos?" subtitle={ABOUT_CONTENT.subtitle} />
        </Who>
        <MvvGrid>
          {ABOUT_CONTENT.mvv.map((item) => (
            <MVVItem key={item.id} title={item.title} description={item.description} Icon={item.Icon} />
          ))}
        </MvvGrid>
      </Reveal>
    </AboutContainer>
  );
};

export default About;